<template>
  <div class="notification-container" v-if="notifications.length">
    <NotificationBar
      v-for="notification in notifications"
      :key="notification.id"
      :notification="notification"
      :error="notification.error"
    />
  </div>
</template>

<script>
import NotificationBar from "@/components/NotificationBar.vue";
import { mapState } from "vuex";

export default {
  components: {
    NotificationBar
  },
  computed: mapState("notification", ["notifications"])
};
</script>

<style scoped>
.notification-container {
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 15px;
  margin-bottom: 20px;
}
</style>
